import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type ServiceEventType = DatabaseCode;

const snow: ServiceEventType = {
  code: "SNOW",
  displayValue: {
    id: "common.entity.serviceeventtype.snow",
    defaultMessage: "Snow",
  },
};

export const serviceEventType = {
  snow,
};

export const serviceEventTypes: ServiceEventType[] = Object.values(serviceEventType);

export const toServiceEventType = (code: string): ServiceEventType =>
  toDatabaseCode(code, serviceEventTypes);

export const toServiceEventTypeSafely = (
  code: string | undefined,
  defaultValue: ServiceEventType | undefined = undefined
): ServiceEventType | undefined => toDatabaseCodeSafely(code, serviceEventTypes, defaultValue);
